export enum FontFamily {
  inter = 'Inter, Arial, "Helvetica Neue", sans-serif',
  mono = 'MonoLisa, "Source Code Pro", Courier, FreeMono, "SF Mono", Monaco, Menlo, Consolas, "Ubuntu Mono", "Liberation Mono", "DejaVu Sans Mono", "Courier New", monospace',
}

export enum FontSize {
  small = 12,
  medium = 14,
  large = 16,
}

export enum LineHeight {
  small = 16,
  medium = 20,
  large = 24,
}
